<script>
import {ref} from 'vue'

import FileUpload from 'vue-upload-component'
import LoadingScreen from '@/components/General/LoadingScreen'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';

//data
import { getAccessRightsOptions } from '@/services/serviceAccessRight';
import { getLibraryInfo } from '@/services/serviceLibrary';
import { getDataToUpload, uploadDocUrl } from '@/services/serviceDocument';

export default {
	name: 'UploadPhoto',
	mixins: [ MixinGeneralFunct ],
	components: {
		FileUpload
		,LoadingScreen
	},
	
	props: {'libraryId': String, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},
	emits: ["libraryId"],

	setup() {
		//console.log(props);
		const upload = ref(null)
		
		const files = ref([])
		function inputFilter(newFile, oldFile, prevent) {
			if (newFile && !oldFile) {
				// Before adding a file
				// 添加文件前
				// Filter system files or hide files
				// 过滤系统文件 和隐藏文件
				if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
				return prevent()
				}
				
				// Filter php html js file
				// 过滤 php html js 文件
				if (/\.(php?|php5?|html?|jsx?)$/i.test(newFile.name)) {
				return prevent()
				}
			}
		}

		function inputFile(newFile, oldFile) {
				//console.log('response', newFile.response)
				if (newFile && !oldFile) {
					// add
					//console.log('add', newFile)
					newFile.sizeView=niceBytes(newFile.size);
				}
				if (newFile && oldFile) {
					// update
					//console.log('update', newFile)
					newFile.sizeView=niceBytes(newFile.size);
				}
				if (!newFile && oldFile) {
					// remove
					//console.log('remove', oldFile)
				}

				//emit('change-record');
							
			}
			return {
			files,
			upload,
			inputFilter,
			inputFile,
		}

		function niceBytes(x){
			const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
			let l = 0, n = parseInt(x, 10) || 0;
			while(n >= 1024 && ++l){
				n = n/1024;
			}
			return(n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
		}
	},

	
	data() {
		return {
			metaData: [],

			isLoading:true,
			
			//form
			library:[],
			access:'5',
			accessError:false,
						
			optionsAccessLevels:[],

			uploadUrl:''
		}
	},
	
	mounted:function(){
		
	},
	
	methods: {
		// load data form
		loadDefaultValues:function(){
			//console.log(this.libraryId)
			this.isLoading=true
			console.log(this.libraryId)
			if(this.libraryId){

				getDataToUpload().then(response => {
					if(!response.statusText){
						this.access = response.access;
						this.uploadUrl=uploadDocUrl();
						this.isLoading=false
					}else{
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});

				getAccessRightsOptions().then(response => {
					if(!response.statusText){
						this.optionsAccessLevels = response.optionsAccessLevels;
					}else{
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});

				getLibraryInfo({libraryId:this.selectedLibrary}).then(response => {
					if(!response.statusText){
						this.library = response.data;
					}else{
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});

				

			}
		
		},
		
		onCloseModal:function(){
			this.modalObject.hide();
		},

		checkUpload:function(){
			if(this.libraryId){
				if(!this.access){this.accessError = true; }else{this.accessError = false;}
				
				if(this.access){
					return true;
				}else{
					this.createMessageBox('warning','Upload',this.$t('msgCore.fillInAllData'));
					return false;
				}
			}
		},

		
		
	},
	
	watch: {
		libraryId() {
			this.loadDefaultValues();
		}
	},

	computed:{
		
	},
	
}

</script>

<template>
	<div>
	<div class="modal fade" :id="modalId" tabindex="-1" >
			<div class="modal-dialog modal-fullscreen">
				<LoadingScreen :isLoading="isLoading"></LoadingScreen>
			<div class="modal-content">
				<div class="modal-header">
					<h6 class="modal-title">{{ $t('msgCore.Upload') }} <span><b>{{ library.title }}</b> </span></h6>
				</div>
		
				<div class="modal-body">
					
					<div class="row">
								
						<div class="col-12">
					
							<div class="form-row">
								
								<div class="form-group col-md-4 col-12">
									<label><b>{{ $t('msgCore.AccessLevel') }}</b></label>
									<select v-model='access' class="form-control form-control-sm" :class="{'is-invalid':accessError}" v-on:change="checkUpload()" >
										<option  value="">{{ $t('msgCore.selectLevel') }}</option>
										<option v-for="(option) in optionsAccessLevels" :value="option.value" :key="option.value">{{ option.title }}</option>
									</select>
									<div v-show="accessError" class="error-input">Vyberte úroveň</div>
								</div>

									
								
							</div>
					
						
					
							<div class="row" v-if="this.checkUpload()">
								<div class="col-12">
									<file-upload
									:input-id="`fil${modalId}`"
									class="btn btn-primary btn-sm"
									:post-action="uploadUrl"
									extensions="pdf,doc,docx,xls,xlsx,csv,jpg,jpeg,pptx,ppt,pps,ppsx,png,webp,rtf"
									accept="image/png,image/jpeg,image/webp,application/pdf,application/vnd.ms-powerpoint,text/csv,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/rtf"
									:data="{libraryId:this.libraryId,accessId:this.access}"
									
									:multiple="true"
									
									v-model="files"
									@input-filter="inputFilter"
									@input-file="inputFile"
									ref="upload">
									<i class="fa fa-plus"></i>
									1. Vyberte súbory
									</file-upload>
								</div>
							</div>

							<div class="row">
								<div class="col-12">
									<table class="table table-hover">
											<tr>
												<th>Názov</th>	
												<th>Typ</th>	
												<th>Veľkosť</th>	
												<th>Chyba</th>	
												<th>Progress</th>	
												<th>Stav nahratia</th>
											</tr>
											<tr v-for="file in files" :key="file">
												<td>{{file.name}}</td>
												<td>{{file.type}}</td>
												<td>{{file.sizeView}}</td>
												<td>{{file.error}}</td>
												<td>
													<div class="progress" v-if="file.active || file.progress !== '0.00'">
													<div :class="{'progress-bar': true, 'progress-bar-striped': true, 'bg-danger': file.error, 'progress-bar-animated': file.active}" role="progressbar" :style="{width: file.progress + '%'}">{{file.progress}}%</div>
													</div>
												</td>	
												<td><i v-if="file.success" class="fa fa-check text-success"></i><i v-if="!file.success" class="fa fa-times text-danger"></i></td>
											</tr>
										
									</table>
								</div>
							</div>

							<div class="row">
								<div class="col-12">
									<button type="button" class="btn btn-success btn-sm" v-if="this.checkUpload() && (!$refs.upload || !$refs.upload.active)" @click.prevent="$refs.upload.active = true">
									<i class="fa fa-arrow-up" aria-hidden="true"></i>
									2. Začať nahrávať
									</button>
							
								</div>
							</div>
					
						</div>	
										
												
												
					</div>
					
				</div>
				
				<div class="modal-footer">
					<div class="btn-group">
						<button type="button" v-on:click="onCloseModal()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>
					</div>	
				</div>
					
			</div>

		</div>
		
	</div>
</div>
</template>


